var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/hardware/keyboard_tab_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 15.375L15 15.375L15 16.875L3 16.875L3 15.375ZM9.75 11.7525L12.4425 9.0675L13.5 10.125L9 14.625L4.5 10.125L5.5575 9.06L8.25 11.7525L8.25 1.125L9.75 1.125L9.75 11.7525Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAlt);
export default __webpack_public_path__ + "static/media/download-alt.1aff25d256fe266612ab61dfc8796558.svg";
export { ForwardRef as ReactComponent };